import {
  ContentType,
  NavTreeItem,
  WebsiteBM,
  WebsiteConfigBM,
  WebsiteConfigPage,
} from '@bm-js/atlascloud-shared'
import { createContext, Dispatch, SetStateAction } from 'react'

export enum FullScreenMode {
  desktop = 'desktop',
  mobile = 'mobile',
}
export interface EditorBackendResponse {
  website: WebsiteBM
  websiteConfig: WebsiteConfigBM
  isPublished: boolean
}

export interface EditorUI {
  fullScreen: FullScreenMode | null
  leftBarOpen: boolean
}

export interface EditorCenterSettings {
  width: number
  height: number
  left: number
  top: number
}

export const editorUiDefault: EditorUI = {
  fullScreen: null,
  leftBarOpen: true,
}

export interface EditorState {
  editorData?: {
    backendResponse: Omit<EditorBackendResponse, 'websiteConfig'>
    navTree: NavTreeItem[]
    workingConfig: WebsiteConfigBM
    activePage: WebsiteConfigPage | null
    activeContent: ContentType<unknown> | null
    breadcrumbs: WebsiteConfigPage[]
  }

  actions: {
    setUi: Dispatch<SetStateAction<EditorUI>>
    toggleLeftBar: () => void
    saveConfig: () => Promise<void>
    publishConfig: () => Promise<void>
    setActivePage: (pageUuid: string) => void
    setActiveContent: (contentUuid: string | null) => void
    patchConfig: (updatedConfig: Partial<WebsiteConfigBM>) => void
    patchActivePage: (updatedPage: Partial<WebsiteConfigPage>) => void
    patchActiveContent: (updatedContent: Partial<ContentType<unknown>>) => void
  }
  status: {
    isLoading: boolean
    isError: boolean
    isSaved: boolean
    isSaving: boolean
    isPublished: boolean
    isPublishing: boolean
  }
  ui: EditorUI
  centerSettings: EditorCenterSettings
}

export const EditorContext = createContext<EditorState>({
  actions: {
    saveConfig: () => Promise.resolve(),
    publishConfig: () => Promise.resolve(),
    setActivePage: () => {},
    setActiveContent: () => {},
    patchConfig: () => {},
    patchActivePage: () => {},
    patchActiveContent: () => {},
    setUi: () => {},
    toggleLeftBar: () => {},
  },
  status: {
    isError: false,
    isLoading: false,
    isSaved: false,
    isSaving: false,
    isPublished: false,
    isPublishing: false,
  },
  ui: editorUiDefault,
  centerSettings: {
    left: 0,
    width: 0,
    height: 0,
    top: 0,
  },
})
